import { Input as BaseInput } from '@base-ui-components/react/input'
import { cn } from '../../utils/cn'

export function TextInput({
  className,
  size = 'md',
  variant = 'outline',
  ...props
}: TextInput.Props) {
  return (
    <BaseInput
      className={cn(
        // Base
        'flex rounded-md placeholder:text-gray-400',
        // Focus
        'focus-visible:ring-accent-600 focus-visible:outline-none focus-visible:ring-2',
        // Disabled
        'disabled:cursor-not-allowed disabled:opacity-50',
        // Hide native controls
        '[&::-webkit-calendar-picker-indicator]:hidden [&::-webkit-inner-spin-button]:hidden [&::-webkit-outer-spin-button]:hidden',
        // Size
        {
          sm: 'h-7 px-2 text-xs',
          md: 'h-9 px-3 text-sm',
        }[size],
        // Variant
        {
          ghost: 'hover:bg-gray-100 focus-visible:bg-gray-100',
          outline: 'bg-background shadow-xs ring ring-inset ring-gray-200',
        }[variant],
        className
      )}
      {...props}
    />
  )
}

export namespace TextInput {
  export interface Props extends Omit<BaseInput.Props, 'size'> {
    size?: 'sm' | 'md'
    variant?: 'ghost' | 'outline'
  }
}
